const MARKETING_QUERY_KEYS = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'ref',
])

/** Preserve attribution parameters across internal public-site CTAs without copying arbitrary input. */
export function withMarketingQuery(destination: string, currentSearch: string): string {
  const [pathname, destinationSearch = ''] = destination.split('?')
  const next = new URLSearchParams(destinationSearch)
  const current = new URLSearchParams(currentSearch)

  current.forEach((value, key) => {
    if (MARKETING_QUERY_KEYS.has(key) && !next.has(key)) {
      next.set(key, value)
    }
  })

  const query = next.toString()
  return query ? `${pathname}?${query}` : pathname
}
